// src/utils/processPolyfill.js
/**
 * Process polyfill utility
 * Ensures 'process' and 'process.env' are available in browser environments
 * This should be imported at the very beginning of your entry file (index.js)
 */

// Define default environment variables
const defaultEnv = {
  NODE_ENV: 'development',
  PUBLIC_URL: '',
  REACT_APP_API_BASE_URL: 'https://d3d8378t728e1f.cloudfront.net',
  // Add other environment variables as needed
};

// Safely get the global object (works in browser, Node.js, and Web Workers)
const getGlobalObject = () => {
  if (typeof window !== 'undefined') return window;
  if (typeof global !== 'undefined') return global;
  // Remove reference to 'self' to fix ESLint warning
  return {};
};

// Get the global object
const globalObj = getGlobalObject();

// Create a safe process object with default values
const safeProcess = {
  env: { ...defaultEnv }
};

// Add process to global object if needed
if (typeof globalObj.process === 'undefined') {
  globalObj.process = safeProcess;
} 
// If process exists but env doesn't, add env
else if (typeof globalObj.process.env === 'undefined') {
  globalObj.process.env = { ...defaultEnv };
}
// If both exist, ensure default values are present
else {
  globalObj.process.env = {
    ...defaultEnv,
    ...globalObj.process.env
  };
}

// Export for convenience
export const processEnv = globalObj.process.env;

export default globalObj.process;